import { z } from 'zod';

export const preferredLanguageSchema = z.enum(['en', 'nb', 'de', 'cs', 'fi', 'sv']);

export type PreferredLanguage = z.infer<typeof preferredLanguageSchema>;

export const preferredLanguageOptions: { value: PreferredLanguage; label: string }[] = [
  { value: 'en', label: 'English' },
  { value: 'nb', label: 'Norsk' },
  { value: 'de', label: 'Deutsch' },
  { value: 'cs', label: 'Čeština' },
  { value: 'fi', label: 'Suomi' },
  { value: 'sv', label: 'Svenska' },
];
